import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-support-ticket-system',
  templateUrl: './support-ticket-system.html'
})
export class SupportTicketSystemComponent implements OnInit {
  userRole = '';
  isAdmin = false;
  isSupplier = false;
  isBuyer = false;

  constructor(private cookieService: CookieService) {}

  ngOnInit(): void {
    this.setRoleFlags();
  }

  private setRoleFlags(): void {
    const normalizedRole = (this.cookieService.get('userRole') || '').trim().toLowerCase();
    this.userRole = normalizedRole;
    this.isAdmin = normalizedRole === 'admin' || normalizedRole === 'admin user';
    this.isSupplier = normalizedRole === 'suppliers' || normalizedRole === 'supplier';
    this.isBuyer = normalizedRole === 'owner' || normalizedRole === 'buyer';
  }

  get showSupplierView(): boolean {
    return !this.isAdmin && (this.isSupplier || (!this.isBuyer && !this.isSupplier));
  }

  get showBuyerView(): boolean {
    return !this.isAdmin && this.isBuyer;
  }
}
